import { useSearchStore } from '@stores/search.store'

import { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { JobSearch } from '@types'

import { useShallow } from 'zustand/react/shallow'

import { getSerpQueryString } from '@lib/helpers/client'

/**
 * Submits a search
 * @param method {string} - Next.js router navigation method
 * @param params { Partial<JobSearch> } - additional search parameters, overrides the stored search data
 */
export default function useSearchDispatcher(): (params?: Partial<JobSearch>) => void {
  const [nextSearch, setSearch, setNextSearch] = useSearchStore(
    useShallow((state) => [state.nextSearch, state.setSearch, state.setNextSearch]),
  )
  const router = useRouter()

  return useCallback(
    (params) => {
      const search: JobSearch = { ...nextSearch, ...params }
      const url = `/search?${getSerpQueryString(search)}`

      setSearch(search)
      setNextSearch(search)

      router.push(url)
    },
    [nextSearch, setSearch, setNextSearch, router],
  )
}
